import script from "./UserPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPopover.vue?vue&type=script&lang=ts&setup=true"

import "./UserPopover.vue?vue&type=style&index=0&id=e3adf378&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3adf378"]])

export default __exports__